import { render, staticRenderFns } from "./AddRecordOffline.vue?vue&type=template&id=f99ad6d8&scoped=true&"
import script from "./AddRecordOffline.vue?vue&type=script&lang=js&"
export * from "./AddRecordOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99ad6d8",
  null
  
)

export default component.exports